<template>
	<div class="page calculate-twists">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<span class="navigation-title">{{$t('calculate-twists')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main" :key="$route.params.id">
				<form @submit.prvent="calc" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="production-speed">{{$t('production-speed-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="production-speed" v-model="productionSpeed">
										</div>
									</div>
									<label for="spindles-speed">{{$t('spindles-speed-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="spindles-speed" v-model="spindlesSpeed">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<hr>
				<div class="container">
					<div class="content">
						<span class="result">{{result | unit}} {{$t('twists-unit')}}</span>
						<!-- <button>{{$t('save')}}</button> -->
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			productionSpeed: '',
			spindlesSpeed: '',
			result: ''
		};
	},
	mounted() {
		this.calc();
	},
	watch: {
		productionSpeed() {
			this.calc();
		},
		spindlesSpeed() {
			this.calc();
		}
	},
	methods: {
		calc() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			let productionSpeed = this.$utils.sanitize(this.productionSpeed);
			let spindlesSpeed = this.$utils.sanitize(this.spindlesSpeed);

			this.result = spindlesSpeed / productionSpeed;
			this.result = this.$utils.sanitize(this.result);
		}
	},
	filters: {
		unit(value) {
			value = value || 0;
			return value.toFixed(0);
		}
	}
}
</script>